import React from 'react';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { ProductId, ProductReEntryPeriodDays } from 'services/products/types';
import { createStructuredSelector } from 'reselect';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { makeSelectProductReEntryPeriodDays } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    productId: ProductId;
}

interface ConnectedProps {
    productReEntryPeriodDays: ProductReEntryPeriodDays;
}

type Props = OwnProps & ConnectedProps;

export class ProductReEntryPeriodDaysTableCellComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { productReEntryPeriodDays } = this.props;

        return <TableCell>{productReEntryPeriodDays}</TableCell>;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    productReEntryPeriodDays: makeSelectProductReEntryPeriodDays()
});

export default connect(mapStateToProps)(
    ProductReEntryPeriodDaysTableCellComponent
);
